import {BaseEntity} from '../common/base-entity';
import {DriverLicenseInfo} from '../common/driver-license-info';
import {CirfDocument} from './cirf-document';


export class CirfDriverLicense extends BaseEntity {

    driverLicenseInfoDTO: DriverLicenseInfo;
    unityConnectDocumentDTO: CirfDocument;
}
